import { NgModule } from '@angular/core';
import { FilterPipe } from './filterPipe';

@NgModule({
	declarations: [FilterPipe],
	imports: [],
	exports: [FilterPipe],
	providers: [],
})
export class FilterPipeModule {}
